// @flow

import { useCallback } from 'react';
import { useTenant } from '@tectonics/commons/tenant';
import { useEnrollment } from '../context';
import { initiateEnrollment } from '../services/enrollment-api';
import { buildEnrollmentPayload } from '../services/enrollment-payload';
import { collectRiskSignals } from './use-risk-signals';

export function useEnrollmentInitiation(): () => Promise<void> {
  const tenant = useTenant();
  const { data, dispatch } = useEnrollment();

  return useCallback(async () => {
    dispatch({ type: 'START_INITIATION' });

    try {
      const riskSignals = collectRiskSignals();

      const payload = buildEnrollmentPayload({
        contract: data.contract,
        cpf: data.cpf,
        bankId: data.bankId,
        riskSignals,
      });

      const MIN_DISPLAY_MS = 1500;
      const [result] = await Promise.all([
        initiateEnrollment(payload, tenant.code),
        new Promise((resolve) => setTimeout(resolve, MIN_DISPLAY_MS)),
      ]);
      dispatch({ type: 'INITIATION_SUCCESS' });
      window.location.href = result.redirect_url;
    } catch (err) {
      dispatch({ type: 'SET_ERROR', errorMessage: err.message || 'Falha ao iniciar vinculação.' });
    }
  }, [data.contract, tenant.code, data.cpf, data.bankId, dispatch]);
}
